import { NTSReflection } from '@nts/std/utility';

const ROOT_MODEL_TYPE_NAME_META_DATA_IDENTIFICATION_KEY = 'rootModelTypeNameDecoratorMetaDataKey';

export function RootModelTypeNameDecorator(rootModelTypeName: string) {
    return (target: any) => {
        Reflect.defineMetadata(ROOT_MODEL_TYPE_NAME_META_DATA_IDENTIFICATION_KEY, rootModelTypeName, target);
    };
}

export class RootModelTypeNameInspector {

    static META_DATA_KEY = ROOT_MODEL_TYPE_NAME_META_DATA_IDENTIFICATION_KEY;
    static DECORATOR_NAME = '@RootModelTypeNameDecorator';

    static isApplied(subject: any): boolean {
        return NTSReflection.hasClassMetadata(
            ROOT_MODEL_TYPE_NAME_META_DATA_IDENTIFICATION_KEY, subject);
    }

    static getValue(subject: any): string {
        return NTSReflection.getClassMetadata(
            ROOT_MODEL_TYPE_NAME_META_DATA_IDENTIFICATION_KEY, subject);
    }
}
